import {
    type Breakpoint,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import type React from "react";

type Props = {
    show: boolean;
    title: string | null;
    children: React.ReactNode;
    fullWidth?: boolean;
    maxWidth?: Breakpoint;
    handleClose?: () => void | null | Promise<void>;
    handleConfirm?: () => void | null;
    cancelText?: string;
    confirmText?: string;
    loading?: boolean;
    hideCloseButton?: boolean;
    refForm?: string;
    hideConfirmButton?: boolean;
    btnClass?: string;
    modalClass?: string;
};

const ModalBase = ({
    show,
    handleClose,
    title,
    handleConfirm,
    cancelText,
    confirmText,
    loading,
    hideCloseButton,
    hideConfirmButton,
    btnClass,
    modalClass,
    children,
    fullWidth,
    maxWidth,
}: Props) => (
    <Dialog
        open={show}
        onClose={handleClose}
        className={modalClass}
        maxWidth={maxWidth ?? "lg"}
        fullWidth={fullWidth}
    >
        {title !== null && <DialogTitle sx={{fontSize: "1.5em"}}>{title}</DialogTitle>}
        <DialogContent>
            <DialogContentText sx={{pb: 2}} component="div">
                {children}
            </DialogContentText>
        </DialogContent>
        {!(hideConfirmButton && hideCloseButton) && (
            <DialogActions>
                <Grid
                    container
                    sx={{
                        justifyContent: "end",
                        flexDirection: {
                            sx: "column",
                            md: "row",
                        },
                    }}
                >
                    {!hideCloseButton && (
                        <Grid>
                            <Button
                                variant={"contained"}
                                onClick={handleClose}
                                className={btnClass}
                                sx={{
                                    mr: hideConfirmButton ? 0 : 2,
                                }}
                            >
                                {cancelText ? cancelText : "Close"}
                            </Button>
                        </Grid>
                    )}
                    {!hideConfirmButton && (
                        <Grid>
                            <Button
                                variant="contained"
                                onClick={handleConfirm}
                                type="submit"
                                className={btnClass}
                            >
                                {loading ? (
                                    <>
                                        <CircularProgress role="status" aria-hidden="true" />
                                        &nbsp; Loading...
                                    </>
                                ) : (
                                    <>{confirmText ? confirmText : "Confirm"}</>
                                )}
                            </Button>
                        </Grid>
                    )}
                </Grid>
            </DialogActions>
        )}
    </Dialog>
);

export default ModalBase;
